import React, { Dispatch, SetStateAction } from "react";
import { useSelector } from "react-redux";

import { IgSelect } from "@intelligems/ig-theme";
import { MenuItem, SelectChangeEvent } from "@mui/material";

import { selectedVariations } from "../../../../store/slices/variations";

import { GraphConfig, GraphType } from "./graphConfigs";

interface VariationFilterProps {
  filterChoice: string;
  setFilterChoice: Dispatch<SetStateAction<string>>;
  config: GraphConfig;
}
export const VariationFilter = ({
  filterChoice,
  setFilterChoice,
  config,
}: VariationFilterProps) => {
  const variations = useSelector(selectedVariations);
  const handleChange = (event: SelectChangeEvent<any>) => {
    if (config.graphType === GraphType.Histogram) {
      setFilterChoice!(event.target.value as string);
    }
  };

  return (
    <IgSelect
      sx={{ height: "25px", left: -10, width: "90px" }}
      autoWidth={true}
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={filterChoice}
      onChange={handleChange}
    >
      <MenuItem disableTouchRipple={true} dense key={"all"} value={"all"}>
        All
      </MenuItem>
      {variations.map((group) => (
        <MenuItem
          disableTouchRipple={true}
          dense
          key={group.id}
          value={group.name}
        >
          {group.name}
        </MenuItem>
      ))}
    </IgSelect>
  );
};
